import { APIClient } from "./api_helper";
import * as url from "./url_helper";

const api = new APIClient();
// Gets the logged in user data from local session

// get Customers
export const getCustomers = (params = { keyword_search: "" }) => {
  // Extract keyword_search from params object, or use params directly if it's a string
  const keywordSearch = typeof params === 'string' ? params : (params.keyword_search || "");
  
  console.log('getCustomers called with:', { params, keywordSearch });
  
  return api.create(url.GET_CUSTOMERS, { params: { keyword_search: keywordSearch } });
};

// add CUSTOMER
export const addNewCustomer = (customer) => {
  const formData = new FormData();
  formData.append("full_name", customer.full_name || "");
  formData.append("phone", customer.phone || "");
  formData.append("email", customer.email || "");
  formData.append("address", customer.address || "");
  
  return api.upload(url.ADD_NEW_CUSTOMER, formData);
};

// update CUSTOMER
export const updateCustomer = (customer) => {
  const formData = new FormData();
  formData.append("customer_id", customer.customer_id);
  formData.append("full_name", customer.full_name || "");
  formData.append("phone", customer.phone || "");
  formData.append("email", customer.email || "");
  formData.append("address", customer.address || "");
  
  return api.upload(url.UPDATE_CUSTOMER, formData);
};

// delete CUSTOMER
export const deleteCustomer = (customerID) =>
  api.create(url.DELETE_CUSTOMER, {
    params: { customer_ids: [customerID] },
  });

export const getCustomerDetail = (customerID) =>
  api.create(url.GET_CUSTOMER_DETAIL, { params: { customer_id: customerID } });

export const exportCustomer = (dateFrom = null, dateTo = null) => {
  const params = { keyword_search: "" };
  
  // Thêm tham số thời gian nếu có - đồng bộ với Swift API
  if (dateFrom && dateTo) {
    params.start_date = dateFrom;
    params.end_date = dateTo;
  }
  
  // Debug log để kiểm tra tham số
  console.log("📤 EXPORT CUSTOMER API CALL:");
  console.log("   URL:", url.EXPORT_CUSTOMER);
  console.log("   Parameters:", params);
  console.log("   Date From:", dateFrom);
  console.log("   Date To:", dateTo);
  console.log("   " + "-".repeat(50));
  
  return api.create(
    url.EXPORT_CUSTOMER,
    { params },
    {
      headers: {
        "Content-Type": "",
      },
      responseType: "blob",
    }
  );
};
